function datetimeLong(timeZone) {
  return {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    timeZone: timeZone
  };
}
function datetimeMedium(timeZone) {
  return {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    timeZone: timeZone
  };
}
function dateMedium(timeZone) {
  return {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: timeZone
  };
}
function dateTimeSeconds(timeZone) {
  return {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    timeZone: timeZone
  };
}
function dateShort(timeZone) {
  return {
    timeZone: timeZone
  };
}
function timeHourMinute(timeZone) {
  return {
    hour: 'numeric',
    minute: 'numeric',
    timeZone: timeZone
  };
}
export function formatDatetimeLong(value, locale, timezone) {
  return formatDate(value, locale, timezone, datetimeLong);
}
export function formatDateMedium(value, locale, timezone) {
  return formatDate(value, locale, timezone, dateMedium);
}
export function formatDateShort(value, locale, timezone) {
  return formatDate(value, locale, timezone, dateShort);
}
export function formatDatetimeMedium(value, locale, timezone) {
  return formatDate(value, locale, timezone, datetimeMedium);
}
export function formatTimeHourMinute(value, locale, timezone) {
  return formatDate(value, locale, timezone, timeHourMinute);
}
export function formatDateTimeSeconds(value, locale, timezone) {
  return formatDate(value, locale, timezone, dateTimeSeconds);
}
export function formatDate(date, locale, timezone, format) {
  var value = date;
  if (!(value instanceof Date)) {
    value = new Date(value);
  }
  return new Intl.DateTimeFormat(locale, format(timezone)).format(value);
}